import * as React from 'react';
import { Grid } from '@material-ui/core';
import Box from "@material-ui/core/Box";
import Help, { IHelp } from "../help/Help";
import { useEffect, useState } from "react";
import PickUpDate from "./PickUpDate";
import dayjs from "dayjs";
import PickUpDateRecoleccion from './PickUpDateRecoleccion';
import useCommonApi from '../../api/useCommonApi';
import { Solicitud } from '../../entities/solicitudes/Solicitud';
import { recoleccionDestinoReducer } from '../../redux/reducers/recoleccionReducer';
import 'dayjs/locale/es'
import PickUpDateFueraHorario from './PickUpDateFueraHorario';
import moment from 'moment-timezone';
import swal from 'sweetalert2';
import { useSnackbar } from 'notistack';
import { ICotizacionDto } from "../../entities/cotizaciones/ICotizacionDto";
import LoadingDialog from "../controls/LoadingDialog";
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';
import { UndoRounded } from '@material-ui/icons';
import { setSolicitud, setSolicitudCopia } from '../../redux/actions/solicitudActions';
import { ApplicationState } from '../../redux/reducers';
import { connect } from "react-redux"
import { AreaServicio } from '../../entities/catalogos/AreaServicio';
import { Colonia } from '../../entities/catalogos/Colonia';

interface IProps {
    esOrigen: boolean
    aceptaCita: boolean
    value?: Date
    valueRecoleccion?: Date
    horarios?: string[]
    esSolicitud: boolean
    setFecha: (fecha: Date | null) => void
    setFechaRecoleccion: (fecha: Date | null, esEad: boolean) => void,
    setFechaFH: (fecha: Date | null, horaDe: string | null, horaHasta: string | null) => void
    ayuda?: IHelp
    cliente: any
    horarioArea?: any
    valueHoraDe?: string
    valueHoraHasta?: string
    EsFueraHorario?: boolean | false
    areaServicio?: any,
    solicitudCopia?: any,
    recoleccion?: any,
    setFechaCedis: (fechaCedis: Date | null) => void,
    valueCedis?: Date, 
    setSolicitaDeNuevoDestino: (solicita: boolean | null, seleccion : number | null) => void,
    setSolicitaDeNuevoOrigen: (solicita: boolean | null, seleccion : number | null) => void,
    setActualizaOption: (option: number | null) => void,
    esSolicitarDeNuevoOrigen: boolean,
    esSolicitarDeNuevoDestino: boolean,
    esUSA: boolean,
    recoleccionOrigen: any
}

interface DispatchProps {
    setSolicitud: typeof setSolicitud
    setSolicitudCopia: typeof setSolicitudCopia
}

type Props = IProps & DispatchProps

const RecoleccionFecha = ({ esOrigen, aceptaCita, value, valueRecoleccion, horarios, setFecha, setFechaRecoleccion,
                              setFechaFH, esSolicitud, ayuda, cliente, horarioArea, valueHoraDe, valueHoraHasta, recoleccionOrigen,
                              EsFueraHorario, areaServicio, solicitudCopia, recoleccion, setFechaCedis, valueCedis, setSolicitaDeNuevoDestino, setSolicitaDeNuevoOrigen, esSolicitarDeNuevoOrigen=false, esSolicitarDeNuevoDestino = false, esUSA= false }: Props) => {

    const [dialogFecha, setDialogFecha] = useState(false);
    const [dialogFechaRecoleccion, setDialogFechaRecoleccion] = useState(false);
    const [fechaString, setFechaString] = useState(traducirMessage(227));
    const [fechaString2, setFechaString2] = useState(traducirMessage(227));
    const [fechaStringCedis, setFechaStringCedis] = useState(traducirMessage(309));
    const [horaString, setHoraString] = useState(traducirMessage(90));
    const [dialogFechaFueraHorario, setDialogFechaFueraHorario] = useState(false);
    const [fechaStringFueraHorario, setFechaStringFH] = useState(traducirMessage(226));
    const [horaStringFH, setHoraStringFH] = useState(traducirMessage(90));
    const [horaStringCedis, setHoraStringCedis] = useState(traducirMessage(90));                           
    const [seleccionaDefault, setSeleccionaDefault] = useState(true);
    const [campo, setCampo] = useState('');
    const [selectedOption, setSelectedOption] = useState(1);
    const { enqueueSnackbar } = useSnackbar();
    const horaDeP = valueHoraDe ? new Date("2021-01-01 " + "00" + ":00") : new Date()
    const horaHastaP = valueHoraHasta ? new Date("2021-01-01 " +  "00" + ":00") : new Date()
    const apiSource = useCommonApi();
    const [showLoading, setLoading] = useState(false);
    const desFecha = value ? fechaString : fechaString + (esOrigen ? 'recolección' : 'entregar');
    const [ventanaFija , setVentanaFija]= useState({ horaInicio: { hours: 0, minutes: 0 }, horaFin: { hours: 0, minutes: 0 }, lun: 0, mar: 0, mie: 0, jue: 0, vie: 0, sab:0, dom: 0, ventanaEsp:"", ventanaIng:"" });
    const[aplicaReglasVentana,setAplicaReglasVentana] = useState(false);
    const [esRadCedis, setEsRadCedis] = useState(false);
    const [esEadCedis, setEsEadCedis] = useState(false);
    const [dialogFechaCedis, setDialogFechaCedis] = useState(false);
    const [limpiaFechaCita, setLimpiaFechaCita] = useState(solicitudCopia.esSolicitarDeNuevo);
    const [valueCita, setValueCita] = useState(new Date());
    const [valueCitaCedis, setValueCitaCedis] = useState(new Date());
    const [ventanaFijaRequest, setVentanaFijaRequest] = useState(false);
    const recintoAduanal = areaServicio?.recintoAduanal?.[0] ?? recoleccion?.recintoAduanal?.[0];
    const esRecintoAduanal = recintoAduanal?.tipoRecintoID === 1;
    //setFechaString(desFecha);
    
    const abrirDialogFecha = () => {
        if (!validaFecha()) {
            return;
        }
        let mensaje = ''
        if (esOrigen === true) {
            mensaje = traducirMessage(302);
        }
        else{
            mensaje = traducirMessage(304);    
        }
        if(localStorage["tipo_usuario"].toLowerCase() === "invitado"){
            swal.fire({
                titleText: traducirMessage(11), // '¡Atención!',
                text: mensaje, // "No se permite esta recolección para usuario invitado",
                type: 'warning',
            });
        }
        else{
            setDialogFecha(true);
        }
    };

    const abrirDialogFechaCedis = () => {
        validaFechaCedis().then(res => {
            if (!res) {
                let mensaje =''
                if(esOrigen)
                    mensaje = traducirMessage(315) + ' ' + recoleccion?.areaServicio?.nombre;   //"NO SE PERMITE LA RECOLECCIÓN CON CITA CEDIS PARA "
                if(!esOrigen)
                    mensaje = traducirMessage(316) + ' ' + recoleccion?.areaServicio?.nombre;   //"NO SE PERMITE LA ENTREGA CON CITA CEDIS PARA "
                
                swal.fire({
                    titleText: traducirMessage(276), // '¡Atención!',
                    text: mensaje,
                    type: 'warning',
                });
                return;
            }
            let mensaje = ''
            if (esOrigen === true) {
                mensaje = traducirMessage(302);
            }
            else{
                mensaje = traducirMessage(304);    
            }
            if(localStorage["tipo_usuario"].toLowerCase() === "invitado"){
                swal.fire({
                    titleText: traducirMessage(11), // '¡Atención!',
                    text: mensaje, // "No se permite esta recolección para usuario invitado",
                    type: 'warning',
                });
            }
            else{
                setDialogFechaCedis(true);
            }
        });
    };

    const cerrarDialogFecha = () => {
        setDialogFecha(false);
    };

    const cerrarDialogFechaCedis = () => {
        setDialogFechaCedis(false);
    };

    const cerrarDialogFechaRecoleccion = () => {
        setDialogFechaRecoleccion(false);
    };

    const abrirDialogFechaFueraHorario = () => {
        if (!validaFecha()) {
            return;
        }
        let mensaje = ''
        if (esOrigen === true) {
            mensaje = traducirMessage(302);
        }
        else{
            mensaje = traducirMessage(304);    
        }
        if(localStorage["tipo_usuario"].toLowerCase() === "invitado"){
            swal.fire({
                titleText: traducirMessage(11), // '¡Atención!',
                text: mensaje, // "No se permite esta recolección para usuario invitado",
                type: 'warning',
            });
        }
        else{
            setDialogFechaFueraHorario(true);
        }
    };

    const cerrarDialogFechaFueraHorario = () => {
        setDialogFechaFueraHorario(false);
    };

    const validaFecha = () => {
        let mensaje = traducirMessage(202) + ' ' //"NO SE PERMITE LA RECOLECCIÓN CON CITA PARA " 
            + recoleccion?.areaServicio?.nombre;

        if (esOrigen === true) {
            if (recoleccion?.areaServicio?.esRadConCita === false) {

                swal.fire({
                    titleText: traducirMessage(276), // '¡Atención!',
                    text: mensaje,
                    type: 'warning',
                });
                return false;
            }
        }
        else {
            if (recoleccion?.areaServicio?.esEadConCita === false) {
                swal.fire({
                    titleText: traducirMessage(276), // '¡Atención!',
                    text: mensaje,
                    type: 'warning',
                });
                return false;
            }
        }
        return true;
    }
    const verificaAS = async () => {
        let params ={
            paisId: recoleccion.colonia.pais?.id,
            estadoId: recoleccion.colonia.estado?.id,
            ciudadId: recoleccion.colonia.ciudad?.id,
            codigoPostal: recoleccion.colonia?.codigoPostal,
            empresaId: cliente?.empresaID,
            ClienteID: cliente?.id,
            ClienteDistribuidorID: recoleccion.distribuidor?.clienteDistribuidorID
        };
        const result: AreaServicio = await apiSource.obtenerAsync("area-servicio/by-address-cliente-distribuidor", params);
        if(esOrigen) {
            if(result.areaServicioRadEadCedis?.activoRad !== undefined){
                return result.areaServicioRadEadCedis?.activoRad;
            }
            else{
                return false;
            }
        }
        if(!esOrigen) {
            if(result.areaServicioRadEadCedis?.activoEad !== undefined){
                return result.areaServicioRadEadCedis?.activoEad;
            }
            else{
                return false;
            }
        }
            return false
    }

    const validaFechaCedis = async () => {
        let mensaje =''
            if(esOrigen)
                mensaje = traducirMessage(315) + ' ' + recoleccion?.areaServicio?.nombre;   //"NO SE PERMITE LA RECOLECCIÓN CON CITA CEDIS PARA "
            if(!esOrigen)
                mensaje = traducirMessage(316) + ' ' + recoleccion?.areaServicio?.nombre;   //"NO SE PERMITE LA ENTREGA CON CITA CEDIS PARA "

        if (esOrigen === true) {
            if (recoleccion?.areaServicio?.areaServicioRadEadCedis?.activoRad !== undefined) {

                if (recoleccion?.areaServicio?.areaServicioRadEadCedis?.activoRad === false) {

                    swal.fire({
                        titleText: traducirMessage(276), // '¡Atención!',
                        text: mensaje,
                        type: 'warning',
                    });
                    return false;
                }
            }
            else
            {
                return  verificaAS();
            }
        }
        else {
            if(recoleccion?.areaServicio?.areaServicioRadEadCedis?.activoEad !== undefined) {
                if (recoleccion?.areaServicio?.areaServicioRadEadCedis?.activoEad === false) {
                    swal.fire({
                        titleText: traducirMessage(276), // '¡Atención!',
                        text: mensaje,
                        type: 'warning',
                    });
                    return false;
                }
            }
            else
            {
                return  verificaAS();
            }

        }
        return true;
    }

    useEffect(() => {
        let language = 'es';
        if(recoleccion != undefined) 
            {
                if(recoleccion.paisId == 2)
                esUSA = true;
            }
        let fechaString = "";
        let fechaStringFueraHorario = "";
        let fechaStringCedis = "";
        let horaString = "";
        let horaStringCedis = "";
        let fechaString2 = "";
        let horaStringFH = "";

        value = value instanceof Date && value.getFullYear() === 1 ? undefined : value;
        valueCedis = valueCedis instanceof Date && valueCedis.getFullYear() === 1 ? undefined : valueCedis;

        if (!(solicitudCopia.esSolicitarDeNuevoOrigen!=null?solicitudCopia.esSolicitarDeNuevoOrigen:false) && esOrigen)
        {
            if(value != null && valueCedis == null)
                setValueCita(value);

            if(valueCedis != null)
                setValueCitaCedis(valueCedis);

            fechaString = value && !EsFueraHorario ? dayjs(value, { locale: language }).format('dddd DD MMM YYYY') : traducirMessage(227);
            fechaStringFueraHorario = value && EsFueraHorario ? dayjs(value, { locale: language }).format('dddd DD MMM YYYY') : traducirMessage(226);
            fechaStringCedis = valueCedis && !EsFueraHorario ? dayjs(valueCedis, { locale: language }).format('dddd DD MMM YYYY') : traducirMessage(309);
            fechaString = value && !EsFueraHorario ? dayjs(value, { locale: language }).format('dddd DD MMM YYYY') : traducirMessage(227);
            fechaStringFueraHorario = value && EsFueraHorario ? dayjs(value, { locale: language }).format('dddd DD MMM YYYY') : traducirMessage(226);
            fechaStringCedis = valueCedis && !EsFueraHorario ? dayjs(valueCedis, { locale: language }).format('dddd DD MMM YYYY') : traducirMessage(309);
            if(localStorage.getItem("idioma")==='en-US'){
                language = 'en';
                fechaString = value && !EsFueraHorario ? dayjs(value, { locale: language }).format('dddd MMM DD YYYY') : traducirMessage(227);
                fechaStringFueraHorario = value && EsFueraHorario ? dayjs(value, { locale: language }).format('dddd MMM DD YYYY') : traducirMessage(226);
                fechaStringCedis = valueCedis && !EsFueraHorario ? dayjs(valueCedis, { locale: language }).format('dddd MMM DD YYYY') : traducirMessage(309);
            }
            
            horaString = value && !EsFueraHorario ? dayjs(value).format('hh:mm A') : traducirMessage(90);
            horaStringCedis = valueCedis && !EsFueraHorario ? dayjs(valueCedis).format('hh:mm A') : traducirMessage(90);
            fechaString2 = new Date().toISOString().slice(0, 10).toString() + 'T00:00';
            horaStringFH = value && EsFueraHorario ? dayjs(new Date("2021-01-01 " + valueHoraDe + ":00")).format('hh:mm A') + " - " + dayjs(new Date("2021-01-01 " + valueHoraHasta + ":00")).format('hh:mm A') : traducirMessage(90)
            if(cliente.clienteConfiguracionRadEadCedis !== undefined && cliente.clienteConfiguracionRadEadCedis !== null && esUSA == false){
                setEsRadCedis(cliente.clienteConfiguracionRadEadCedis.activoRad);
                setEsEadCedis(cliente.clienteConfiguracionRadEadCedis.activoEad);
            }
            setFechaString(value ? (fechaString == traducirMessage(227)) ? fechaString + (esOrigen ? traducirLabel(254) : traducirLabel(118)) : fechaString : fechaString + (esOrigen ? traducirLabel(254) : traducirLabel(118)));
            setFechaString2(fechaString2);
            setHoraString(horaString);
            setFechaStringCedis(valueCedis ? (fechaStringCedis == traducirMessage(309)) ? fechaStringCedis + (esOrigen ? traducirLabel(254) : traducirLabel(118)) : fechaStringCedis : fechaStringCedis + (esOrigen ? traducirLabel(254) : traducirLabel(118)));
            setHoraStringCedis(horaStringCedis);
            setFechaStringFH(value ? (fechaStringFueraHorario == traducirMessage(226)) ? fechaStringFueraHorario + (esOrigen ? traducirLabel(254) : traducirLabel(118)) : fechaStringFueraHorario : fechaStringFueraHorario + (esOrigen ? traducirLabel(254) : traducirLabel(118)));
            setHoraStringFH(horaStringFH);
        }

        if(esOrigen && solicitudCopia.tipoDeRecoleccionOrigen === undefined && !solicitudCopia.esSolicitarDeNuevoOrigen){
            if ((campo !== "citaFueraHorario" && campo !== "citaCedis") && (campo == 'recoleccion' || ((EsFueraHorario == undefined || !EsFueraHorario) && horaString == traducirMessage(90) && horaStringCedis == traducirMessage(90) && ((esSolicitud && horaStringFH == traducirMessage(90)) || (!esSolicitud && horaStringFH != '') || (campo == ''))))) {
                if(solicitudCopia.EsRadCita == 1){
                    setCampo('cita');
                    setSeleccionaDefault(false);
                    setSelectedOption(2);
                }else if(recoleccion.EsCitaRadCedis){
                    setCampo('citaCedis');
                    setSeleccionaDefault(false);
                    setSelectedOption(4);
                }
                else{
                    setCampo('recoleccion');
                    setSeleccionaDefault(true);
                    setSelectedOption(1);
                    if(valueRecoleccion !== null && valueRecoleccion !== undefined){
                        setFechaRecoleccion(valueRecoleccion, false);
                    }
                }
            }
            else {
                if ((EsFueraHorario == true || campo == 'citaFueraHorario')) {
                    setCampo('citaFueraHorario');
                    setSeleccionaDefault(false);
                    setSelectedOption(3);
                }
                if ((!EsFueraHorario && campo !== "citaFueraHorario" && (campo == 'citaCedis' || (horaStringCedis != traducirMessage(90) && horaStringCedis != '')  || (recoleccion.EsCitaRadCedis  !== undefined && recoleccion.EsCitaRadCedis) || (recoleccion.EsCitaEadCedis  !== undefined && recoleccion.EsCitaEadCedis)))) {
                    setCampo('citaCedis');
                    setSeleccionaDefault(false);
                    setSelectedOption(4);
                } else if(campo !== "citaFueraHorario" && campo !== "citaCedis" && EsFueraHorario !== true) {
                    setCampo('cita');
                    setSeleccionaDefault(false);
                    setSelectedOption(2);
                }
            }
        }
        if(esOrigen && solicitudCopia.tipoDeRecoleccionOrigen !== undefined && solicitudCopia.esSolicitarDeNuevoOrigen === undefined){
            if(recoleccion.tipoDeRecoleccionOrigen!== undefined){
                if(recoleccion.tipoDeRecoleccionOrigen === 1){
                    setSolicitaDeNuevoOrigen(false, 1);
                    setCampo('recoleccion');
                    setSeleccionaDefault(true);
                    setSelectedOption(1);
                    if(valueRecoleccion !== null && valueRecoleccion !== undefined){
                        setFechaRecoleccion(valueRecoleccion, false);
                    }
                }
                if(recoleccion.tipoDeRecoleccionOrigen === 2){
                    if(solicitudCopia.esSolicitarDeNuevoOrigen){
                        setSolicitaDeNuevoOrigen(false, 2);
                        setFecha(null);
                    }
                    
                    setCampo('cita');
                    setSeleccionaDefault(false);
                    setSelectedOption(2);
                }
                if(recoleccion.tipoDeRecoleccionOrigen === 3){
                    if(solicitudCopia.esSolicitarDeNuevoOrigen){
                        setSolicitaDeNuevoOrigen(false, 3);
                        setFecha(null);
                        setFechaFH(null,null,null);
                    }
                    
                    setCampo('citaFueraHorario');
                    setSeleccionaDefault(false);
                    setSelectedOption(3);
                }
                if(recoleccion.tipoDeRecoleccionOrigen === 4){
                    if(solicitudCopia.esSolicitarDeNuevoOrigen){
                        setSolicitaDeNuevoOrigen(false, 4);
                        setFecha(null);
                        setFechaCedis(null);
                    }
                    
                    setCampo('citaCedis');
                    setSeleccionaDefault(false);
                    setSelectedOption(4);
                }
            }
            else{
                if(solicitudCopia.tipoDeRecoleccionOrigen === 1){
                    setSolicitaDeNuevoOrigen(false, 1);
                    setCampo('recoleccion');
                    setSeleccionaDefault(true);
                    setSelectedOption(1);
                    if(valueRecoleccion !== null && valueRecoleccion !== undefined){
                        setFechaRecoleccion(valueRecoleccion, false);
                    }
                }
                if(solicitudCopia.tipoDeRecoleccionOrigen === 2){
                    if(solicitudCopia.esSolicitarDeNuevoOrigen){
                        setSolicitaDeNuevoOrigen(false, 2);
                        setFecha(null);
                    }
                    
                    setCampo('cita');
                    setSeleccionaDefault(false);
                    setSelectedOption(2);
                }
                if(solicitudCopia.tipoDeRecoleccionOrigen === 3){
                    if(solicitudCopia.esSolicitarDeNuevoOrigen){
                        setSolicitaDeNuevoOrigen(false, 3);
                        setFecha(null);
                        setFechaFH(null,null,null);
                    }
                    
                    setCampo('citaFueraHorario');
                    setSeleccionaDefault(false);
                    setSelectedOption(3);
                }
                if(solicitudCopia.tipoDeRecoleccionOrigen === 4){
                    if(solicitudCopia.esSolicitarDeNuevoOrigen){
                        setSolicitaDeNuevoOrigen(false, 4);
                        setFecha(null);
                        setFechaCedis(null);
                    }
                    
                    setCampo('citaCedis');
                    setSeleccionaDefault(false);
                    setSelectedOption(4);
                }
            }
            
        }

        if (!esOrigen)
            {
                if(recoleccion != undefined) 
                    {
                        if(recoleccion.paisId == 2)
                        esUSA = true;
                    }
                if(value != null)
                    setValueCita(value);

                if(valueCedis != null)
                    setValueCitaCedis(valueCedis);
    
                fechaString = value && !EsFueraHorario ? dayjs(value, { locale: language }).format('dddd DD MMM YYYY') : traducirMessage(227);
                fechaStringFueraHorario = value && EsFueraHorario ? dayjs(value, { locale: language }).format('dddd DD MMM YYYY') : traducirMessage(226);
                fechaStringCedis = valueCedis && !EsFueraHorario ? dayjs(valueCedis, { locale: language }).format('dddd DD MMM YYYY') : traducirMessage(309);
                fechaString = value && !EsFueraHorario ? dayjs(value, { locale: language }).format('dddd DD MMM YYYY') : traducirMessage(227);
                fechaStringFueraHorario = value && EsFueraHorario ? dayjs(value, { locale: language }).format('dddd DD MMM YYYY') : traducirMessage(226);
                fechaStringCedis = valueCedis && !EsFueraHorario ? dayjs(valueCedis, { locale: language }).format('dddd DD MMM YYYY') : traducirMessage(309);
                if(localStorage.getItem("idioma")==='en-US'){
                    language = 'en';
                    fechaString = value && !EsFueraHorario ? dayjs(value, { locale: language }).format('dddd MMM DD YYYY') : traducirMessage(227);
                    fechaStringFueraHorario = value && EsFueraHorario ? dayjs(value, { locale: language }).format('dddd MMM DD YYYY') : traducirMessage(226);
                    fechaStringCedis = valueCedis && !EsFueraHorario ? dayjs(valueCedis, { locale: language }).format('dddd MMM DD YYYY') : traducirMessage(309);
                }
                
                horaString = value && !EsFueraHorario ? dayjs(value).format('hh:mm A') : traducirMessage(90);
                horaStringCedis = valueCedis && !EsFueraHorario ? dayjs(valueCedis).format('hh:mm A') : traducirMessage(90);
                fechaString2 = new Date().toISOString().slice(0, 10).toString() + 'T00:00';
                horaStringFH = value && EsFueraHorario ? dayjs(new Date("2021-01-01 " + valueHoraDe + ":00")).format('hh:mm A') + " - " + dayjs(new Date("2021-01-01 " + valueHoraHasta + ":00")).format('hh:mm A') : traducirMessage(90)
                if(cliente.clienteConfiguracionRadEadCedis !== undefined && cliente.clienteConfiguracionRadEadCedis !== null && esUSA == false){
                    setEsRadCedis(cliente.clienteConfiguracionRadEadCedis.activoRad);
                    setEsEadCedis(cliente.clienteConfiguracionRadEadCedis.activoEad);
                }
        
                
                setFechaString(value ? (fechaString == traducirMessage(227)) ? fechaString + (esOrigen ? traducirLabel(254) : traducirLabel(118)) : fechaString : fechaString + (esOrigen ? traducirLabel(254) : traducirLabel(118)));
                setFechaString2(fechaString2);
                setHoraString(horaString);
                setFechaStringCedis(valueCedis ? (fechaStringCedis == traducirMessage(309)) ? fechaStringCedis + (esOrigen ? traducirLabel(254) : traducirLabel(118)) : fechaStringCedis : fechaStringCedis + (esOrigen ? traducirLabel(254) : traducirLabel(118)));
                setHoraStringCedis(horaStringCedis);
                setFechaStringFH(value ? (fechaStringFueraHorario == traducirMessage(226)) ? fechaStringFueraHorario + (esOrigen ? traducirLabel(254) : traducirLabel(118)) : fechaStringFueraHorario : fechaStringFueraHorario + (esOrigen ? traducirLabel(254) : traducirLabel(118)));
                setHoraStringFH(horaStringFH);

                if(solicitudCopia.tipoDeRecoleccionDestino !== undefined){
                    if(recoleccion.tipoDeRecoleccionDestino!== undefined){
                        if(recoleccion.tipoDeRecoleccionDestino === 1){
                            if ((campo !== "citaFueraHorario" && campo !== "citaCedis" && !recoleccion.EsCitaEadCedis) && (campo == 'recoleccion' || ((EsFueraHorario == undefined || !EsFueraHorario) && horaString == traducirMessage(90) && horaStringCedis == traducirMessage(90) && ((esSolicitud && horaStringFH == traducirMessage(90)) || (!esSolicitud && horaStringFH != '') || (campo == ''))))) {
                                setCampo('recoleccion');
                                //removeFecha();
                                setSeleccionaDefault(true);
                                setSelectedOption(1);
                                //setFechaRecoleccion(null);
                                if(valueRecoleccion !== null && valueRecoleccion !== undefined){
                                    setFechaRecoleccion(valueRecoleccion, false);
                                }
                            }
                        }
                            if(recoleccion.tipoDeRecoleccionDestino === 2){
                                if(EsFueraHorario !== true) {
                                    setCampo('cita');
                                    setSeleccionaDefault(false);
                                    setSelectedOption(2);
                                }
                            }
                            if(recoleccion.tipoDeRecoleccionDestino === 3){
                                if ((EsFueraHorario == true || campo == 'citaFueraHorario')) {
                                    setCampo('citaFueraHorario');
                                    setSeleccionaDefault(false);
                                    setSelectedOption(3);
                                }
                            }
                            if(recoleccion.tipoDeRecoleccionDestino === 4){
                                if (campo !== "citaFueraHorario" && ((campo == 'citaCedis' || (horaStringCedis != traducirMessage(90) && horaStringCedis != '')  || (recoleccion.EsCitaRadCedis  !== undefined && recoleccion.EsCitaRadCedis) || (recoleccion.EsCitaEadCedis  !== undefined && recoleccion.EsCitaEadCedis)))) {
                                    setCampo('citaCedis');
                                    setSeleccionaDefault(false);
                                    setSelectedOption(4);
                            }
                        }
                    }
                    else{
                        if(solicitudCopia.tipoDeRecoleccionDestino === 1){
                            if ((campo !== "citaFueraHorario" && campo !== "citaCedis" && !recoleccion.EsCitaEadCedis) && (campo == 'recoleccion' || ((EsFueraHorario == undefined || !EsFueraHorario) && horaString == traducirMessage(90) && horaStringCedis == traducirMessage(90) && ((esSolicitud && horaStringFH == traducirMessage(90)) || (!esSolicitud && horaStringFH != '') || (campo == ''))))) {
                                setCampo('recoleccion');
                                setSeleccionaDefault(true);
                                setSelectedOption(1);
                                //setFechaRecoleccion(null);
                                //removeFecha();
                                if(valueRecoleccion !== null && valueRecoleccion !== undefined){
                                    setFechaRecoleccion(valueRecoleccion, false);
                                }
                            }
                        }
                            if(solicitudCopia.tipoDeRecoleccionDestino === 2){
                                if(EsFueraHorario !== true && campo !== "recoleccion") {
                                    setCampo('cita');
                                    setSeleccionaDefault(false);
                                    setSelectedOption(2);
                                }
                            }
                            if(solicitudCopia.tipoDeRecoleccionDestino === 3){
                                if ((EsFueraHorario == true || campo == 'citaFueraHorario')) {
                                    setCampo('citaFueraHorario');
                                    setSeleccionaDefault(false);
                                    setSelectedOption(3);
                                }
                            }
                            if(solicitudCopia.tipoDeRecoleccionDestino === 4){
                                if (campo !== "citaFueraHorario" && campo !== "recoleccion" && ((campo == 'citaCedis' || (horaStringCedis != traducirMessage(90) && horaStringCedis != '')  || (recoleccion.EsCitaRadCedis  !== undefined && recoleccion.EsCitaRadCedis) || (recoleccion.EsCitaEadCedis  !== undefined && recoleccion.EsCitaEadCedis)))) {
                                    if(esUSA)
                                    {
                                        setCampo('recoleccion');
                                        setSelectedOption(1);
                                    }
                                    else
                                    {
                                        setCampo('citaCedis');
                                        setSeleccionaDefault(false);
                                        setSelectedOption(4);
                                    }
                                    
                            }
                        }
                    }                    
                }
                if(solicitudCopia.tipoDeRecoleccionDestino === undefined){
                    if(recoleccion.tipoDeRecoleccionDestino!== undefined){
                        if(recoleccion.tipoDeRecoleccionDestino === 1){
                            if ((campo !== "citaFueraHorario" && campo !== "citaCedis" && !recoleccion.EsCitaEadCedis) && (campo == 'recoleccion' || ((EsFueraHorario == undefined || !EsFueraHorario) && horaString == traducirMessage(90) && horaStringCedis == traducirMessage(90) && ((esSolicitud && horaStringFH == traducirMessage(90)) || (!esSolicitud && horaStringFH != '') || (campo == ''))))) {
                                setCampo('recoleccion');
                                //removeFecha();
                                setSeleccionaDefault(true);
                                setSelectedOption(1);
                                //setFechaRecoleccion(null);
                                if(valueRecoleccion !== null && valueRecoleccion !== undefined){
                                    setFechaRecoleccion(valueRecoleccion, false);
                                }
                            }
                        }
                            if(recoleccion.tipoDeRecoleccionDestino === 2){
                                if(EsFueraHorario !== true) {
                                    setCampo('cita');
                                    setSeleccionaDefault(false);
                                    setSelectedOption(2);
                                }
                            }
                            if(recoleccion.tipoDeRecoleccionDestino === 3){
                                if ((EsFueraHorario == true || campo == 'citaFueraHorario')) {
                                    setCampo('citaFueraHorario');
                                    setSeleccionaDefault(false);
                                    setSelectedOption(3);
                                }
                            }
                            if(recoleccion.tipoDeRecoleccionDestino === 4){
                                if (campo !== "citaFueraHorario" && ((campo == 'citaCedis' || (horaStringCedis != traducirMessage(90) && horaStringCedis != '')  || (recoleccion.EsCitaRadCedis  !== undefined && recoleccion.EsCitaRadCedis) || (recoleccion.EsCitaEadCedis  !== undefined && recoleccion.EsCitaEadCedis)))) {
                                    setCampo('citaCedis');
                                    setSeleccionaDefault(false);
                                    setSelectedOption(4);
                            }
                        }
                    }
                    else{
                        if ((campo !== "citaFueraHorario" && campo !== "citaCedis" && (!recoleccion.EsCitaEadCedis || campo ==='recoleccion')) && (campo == 'recoleccion' || ((EsFueraHorario == undefined || !EsFueraHorario) && horaString == traducirMessage(90) && horaStringCedis == traducirMessage(90) && ((esSolicitud && horaStringFH == traducirMessage(90)) || (!esSolicitud && horaStringFH != '') || (campo == ''))))) {
                            setCampo('recoleccion');
                            setSeleccionaDefault(true);
                            setSelectedOption(1);
                            //removeFecha();
                            setFechaRecoleccion(null, true);
                            if(valueRecoleccion !== null && valueRecoleccion !== undefined){
                                setFechaRecoleccion(valueRecoleccion, false);
                            }
                        }
                        else {
                            if ((EsFueraHorario == true || campo == 'citaFueraHorario')) {
                                setCampo('citaFueraHorario');
                                setSeleccionaDefault(false);
                                setSelectedOption(3);
                            }
                            if (!EsFueraHorario && campo !== "citaFueraHorario" && (campo == 'citaCedis' || (horaStringCedis != traducirMessage(90) && horaStringCedis != '')  || (recoleccion.EsCitaRadCedis  !== undefined && recoleccion.EsCitaRadCedis) || (recoleccion.EsCitaEadCedis  !== undefined && recoleccion.EsCitaEadCedis))) {
                                setCampo('citaCedis');
                                setSeleccionaDefault(false);
                                setSelectedOption(4);
                            } else if(campo !== "citaFueraHorario" && campo !== "citaCedis" && EsFueraHorario !== true) {
                                setCampo('cita');
                                setSeleccionaDefault(false);
                                setSelectedOption(2);
                            }
                        }       
                    }
                }
            }

        if(!ventanaFijaRequest && esSolicitud && (cliente.clienteConfiguracionVentanaServicio?.activo??false)===true)
        {
            getVentanaFija().then(res => {
                setVentanaFija({
                    horaInicio: { hours: res.horA_IN.hours, minutes: res.horA_IN.minutes },
                    horaFin: { hours: res.horA_FIN.hours, minutes: res.horA_FIN.minutes },
                    lun: res.lunes, mar: res.martes, mie: res.miercoles, jue: res.jueves, vie: res.viernes, sab: res.sabado, dom: res.domingo,
                    ventanaEsp: res.ventanA_ESPANOL, ventanaIng: res.ventanA_INGLES
                });
                setVentanaFijaRequest(true);
                if(!(res.horA_IN.hours === 0 && res.horA_IN.minutes === 0 && res.horA_FIN.hours=== 0 && res.horA_FIN.minutes===0))
                {
                    setAplicaReglasVentana(true);
                }

            });
        }
        
    }, [value, valueCedis, localStorage.getItem("idioma"), campo]);

    const removeFecha = () => {
        if(recoleccion != undefined) 
            {
                if(recoleccion.paisId == 2)
                esUSA = true;
            }
        if(!esOrigen && campo!=="recoleccion" ){
            setSolicitaDeNuevoDestino(false, 1);
        }
        setFecha(null);
        setFechaCedis(null);
        //setFechaFH(null,null,null);
        setSeleccionaDefault(true);
        setCampo('recoleccion');
        
        let language = 'es';
        let fechaString = "";
        let fechaStringFueraHorario = "";
        let fechaStringCedis = "";
        let horaString = "";
        let horaStringCedis = "";
        let fechaString2 = "";
        let horaStringFH = "";

        value = value instanceof Date && value.getFullYear() === 1 ? undefined : value;
        valueCedis = valueCedis instanceof Date && valueCedis.getFullYear() === 1 ? undefined : valueCedis;

        fechaString = value && !EsFueraHorario ? dayjs(value, { locale: language }).format('dddd DD MMM YYYY') : traducirMessage(227);
                fechaStringFueraHorario = value && EsFueraHorario ? dayjs(value, { locale: language }).format('dddd DD MMM YYYY') : traducirMessage(226);
                fechaStringCedis = valueCedis && !EsFueraHorario ? dayjs(valueCedis, { locale: language }).format('dddd DD MMM YYYY') : traducirMessage(309);
                fechaString = value && !EsFueraHorario ? dayjs(value, { locale: language }).format('dddd DD MMM YYYY') : traducirMessage(227);
                fechaStringFueraHorario = value && EsFueraHorario ? dayjs(value, { locale: language }).format('dddd DD MMM YYYY') : traducirMessage(226);
                fechaStringCedis = valueCedis && !EsFueraHorario ? dayjs(valueCedis, { locale: language }).format('dddd DD MMM YYYY') : traducirMessage(309);
                if(localStorage.getItem("idioma")==='en-US'){
                    language = 'en';
                    fechaString = value && !EsFueraHorario ? dayjs(value, { locale: language }).format('dddd MMM DD YYYY') : traducirMessage(227);
                    fechaStringFueraHorario = value && EsFueraHorario ? dayjs(value, { locale: language }).format('dddd MMM DD YYYY') : traducirMessage(226);
                    fechaStringCedis = valueCedis && !EsFueraHorario ? dayjs(valueCedis, { locale: language }).format('dddd MMM DD YYYY') : traducirMessage(309);
                }
                
                horaString = value && !EsFueraHorario ? dayjs(value).format('hh:mm A') : traducirMessage(90);
                horaStringCedis = valueCedis && !EsFueraHorario ? dayjs(valueCedis).format('hh:mm A') : traducirMessage(90);
                fechaString2 = new Date().toISOString().slice(0, 10).toString() + 'T00:00';
                horaStringFH = value && EsFueraHorario ? dayjs(new Date("2021-01-01 " + valueHoraDe + ":00")).format('hh:mm A') + " - " + dayjs(new Date("2021-01-01 " + valueHoraHasta + ":00")).format('hh:mm A') : traducirMessage(90)
                if(cliente.clienteConfiguracionRadEadCedis !== undefined && cliente.clienteConfiguracionRadEadCedis !== null && esUSA == false){
                    setEsRadCedis(cliente.clienteConfiguracionRadEadCedis.activoRad);
                    setEsEadCedis(cliente.clienteConfiguracionRadEadCedis.activoEad);
                }
        
                
                setFechaString(value ? (fechaString == traducirMessage(227)) ? fechaString + (esOrigen ? traducirLabel(254) : traducirLabel(118)) : fechaString : fechaString + (esOrigen ? traducirLabel(254) : traducirLabel(118)));
                setFechaString2(fechaString2);
                setHoraString(horaString);
                setFechaStringCedis(valueCedis ? (fechaStringCedis == traducirMessage(309)) ? fechaStringCedis + (esOrigen ? traducirLabel(254) : traducirLabel(118)) : fechaStringCedis : fechaStringCedis + (esOrigen ? traducirLabel(254) : traducirLabel(118)));
                setHoraStringCedis(horaStringCedis);
                setFechaStringFH(value ? (fechaStringFueraHorario == traducirMessage(226)) ? fechaStringFueraHorario + (esOrigen ? traducirLabel(254) : traducirLabel(118)) : fechaStringFueraHorario : fechaStringFueraHorario + (esOrigen ? traducirLabel(254) : traducirLabel(118)));
                setHoraStringFH(horaStringFH);

        // let descripcionFechaText = "";
        // let descripcionFechaFHText = "";
        // if (value === null && traducirMessage(227).indexOf(traducirLabel(254)) === -1 && traducirMessage(227).indexOf( traducirLabel(118))) {
        //     descripcionFechaText = traducirMessage(227) + (esOrigen ? traducirLabel(254) : traducirLabel(118));
        // }

        // if (value === null && traducirMessage(226).indexOf(traducirLabel(254)) === -1 && traducirMessage(226).indexOf( traducirLabel(118))) {
        //     descripcionFechaFHText = traducirMessage(226) + (esOrigen ? traducirLabel(254) : traducirLabel(118));
        // }



        // setFechaString(descripcionFechaText);
        // setHoraString(traducirMessage(90));
        // setFechaStringFH(descripcionFechaFHText);
        // setHoraStringFH(traducirMessage(90));
        // setSelectedOption(1);

        if (!esOrigen) {
            setFechaRecoleccion(null, true);
        }

        if (!esSolicitud) {
            setFechaRecoleccion(null, false);
        }
    };

    const saveFecha = async (fecha) => {
        setFecha(fecha);
        if(esOrigen)
            setSolicitaDeNuevoOrigen(false, 2);
        if(!esOrigen)
            setSolicitaDeNuevoDestino(false, 2);
        let esValido = await validaMatriz(fecha);
        if (!esValido)
            return;

        if (validaFechaFueraHorario(fecha)) {
            enqueueSnackbar(traducirMessage(145), //"La fecha proporcionada está fuera del horario de servicio, seleccionar la opción de Cita Fuera de Horario.",
                { variant: "warning" });

            if (!esSolicitud) {
                let nuevaFecha = moment(fecha);
                let hora = nuevaFecha.hours();
                let minuto = nuevaFecha.minutes();
                let horaDe = String(hora).padStart(2, '0') + ":" + String(minuto).padStart(2, '0');

                setCampo('')
                setFechaFH(fecha, horaDe, horaDe);
                setDialogFecha(false);
                setFechaRecoleccion(null, false);
                setDialogFechaFueraHorario(true);
                setCampo('citaFueraHorario');
                setSelectedOption(3);
            }
            return;
        }

        setCampo('')
        setFecha(fecha);
        setSeleccionaDefault(false);
        setCampo('cita');
        setSelectedOption(2);
        setFechaRecoleccion(null, false);
        setDialogFecha(false);
    };

    const saveFechaCedis = async (fecha) => {
        setFechaCedis(fecha);
        if(esOrigen)
            setSolicitaDeNuevoOrigen(false, 4);
        if(!esOrigen)
            setSolicitaDeNuevoDestino(false, 4);
        let esValido = await validaMatriz(fecha);
        if (!esValido)
            return;
        if (validaFechaFueraHorario(fecha)) {
            enqueueSnackbar(traducirMessage(145), //"La fecha proporcionada está fuera del horario de servicio, seleccionar la opción de Cita Fuera de Horario.",
                { variant: "warning" });

            if (!esSolicitud) {
                let nuevaFecha = moment(fecha);
                let hora = nuevaFecha.hours();
                let minuto = nuevaFecha.minutes();
                let horaDe = String(hora).padStart(2, '0') + ":" + String(minuto).padStart(2, '0');

                setCampo('')
                setFechaFH(fecha, horaDe, horaDe);
                setDialogFecha(false);
                setFechaRecoleccion(null, false);
                setDialogFechaFueraHorario(true);
                setCampo('citaFueraHorario');
                setSelectedOption(3);
            }
            return;
        }
        setCampo('');
        setFechaCedis(fecha);
        setSeleccionaDefault(false);
        setCampo('citaCedis');
        setSelectedOption(4);
        setFechaRecoleccion(null, false);
        setDialogFechaCedis(false);
    };

    const validaMatriz = async (fecha) => {
        let sucursalRemitenteId = 0;
        let sucursalDestinatarioId = 0
        let areaServicioRemitenteId = 0;
        let areaServicioDestinatarioId = 0;
        let destinatarioId = 0;
        let ocurreDestino = solicitudCopia.ocurreDestino ?? 0;
        let fechaRecoleccion = solicitudCopia.fechaRecoleccion;
        if (esOrigen) {
            sucursalRemitenteId = recoleccion.sucursal?.id;
            sucursalDestinatarioId = solicitudCopia.sucursalDestino?.id;
            areaServicioRemitenteId = recoleccion.areaServicio?.id;
            areaServicioDestinatarioId = solicitudCopia.areaServicioDestinoId;
            destinatarioId = solicitudCopia.sucursalDestino?.id;
        } else {
            sucursalRemitenteId = solicitudCopia.sucursalOrigen?.id;
            sucursalDestinatarioId = recoleccion.sucursal?.id;
            areaServicioRemitenteId = solicitudCopia.areaServicioOrigenId;
            areaServicioDestinatarioId = recoleccion.areaServicio?.id;
            destinatarioId = recoleccion.distribuidor?.id || recoleccion.sucursal?.id;
        }

        let params = {
            clienteId: cliente.id,
            sucursalRemitenteId: sucursalRemitenteId,
            sucursalDestinatarioId: sucursalDestinatarioId,
            areaServicioRemitenteId: areaServicioRemitenteId,
            areaServicioDestinatarioId: areaServicioDestinatarioId,
            ocurreDestino: ocurreDestino,
            destinatarioId: destinatarioId,
            sticker: "",
            cotizacionId: "",
            solicitudServicioId: "",
            fechaRecoleccion: fechaRecoleccion,
            tipoEnvioId: 1,
            fechaVentana: ""
        };

        const fechaCita = new Date(fecha);
        fechaCita.setMinutes(fecha.getMinutes() - fecha.getTimezoneOffset())
        let params2 = {
            tipo: esOrigen ? "RAD" : "EAD",
            fecha: fechaCita,
            fechaEstimada: new Date(1900, 0, 1)
        }
        setLoading(true);
        if (sucursalDestinatarioId !== undefined) {
            if(recoleccionOrigen.esComercioExterior && recoleccionOrigen.esServicioInternacional){
                params2.fechaEstimada = recoleccionOrigen.fechaRecoleccion;
            }
            else{
                const result = await apiSource.postAsync<any>("/solicitud-servicio/obtener-fecha-envio-estimado", params);
                params2.fechaEstimada = new Date(result.fechA_FIN);
                params2.fechaEstimada?.setMinutes(params2.fechaEstimada?.getMinutes() - params2.fechaEstimada?.getTimezoneOffset())
            }
        }

        const result2 = await apiSource.postAsync<any>("/solicitud-servicio/verificar-fechas", params2);

        if (result2 !== "") {
            setLoading(false);
            enqueueSnackbar(traducirMessage(parseInt(result2)), { variant: "warning" });
            return false;
        }
        setLoading(false);
        return true;
    }


    const validaFechaFueraHorario = (fecha) => {

        let date = moment(fecha);
        let hora = date.hours();
        let minuto = date.minutes();
        let day = date.isoWeekday()
        let esFechaFueraHorario = false;
        let dias: any[] = [];
        for (let i = 0; i < areaServicio.horarios.length; i++) {
            for (let j = 0; j < areaServicio.horarios[i].dias.length; j++) {
                dias.push({
                    id: areaServicio.horarios[i].dias[j].id,
                    fechaEntrada: moment(areaServicio.horarios[i].horaEntrada),
                    fechaSalida: moment(areaServicio.horarios[i].horaSalida)
                });
            }
        }

        let dia = dias.find(a => a.id === day);
        if (dia !== undefined) {
            let year = dia.fechaEntrada.year();
            let month = dia.fechaEntrada.month();
            let numeroDia = dia.fechaEntrada.date();
            let nuevaFecha = moment([year, month, numeroDia, hora, minuto]);
            if (nuevaFecha > dia.fechaSalida || nuevaFecha < dia.fechaEntrada)
                esFechaFueraHorario = true;
        } else
            esFechaFueraHorario = true;

        return esFechaFueraHorario;
    }

    const saveFechaRecoleccion = (fecha) => {
        setCampo('recoleccion');
        setSelectedOption(1);
        setFechaRecoleccion(fecha, false);
        setFecha(null);
        setDialogFecha(false);
        setFechaCedis(null);
        //setFechaFH(null,null,null);
    };

    const saveFechaFueraHorario = async (fecha, horaDe, horaHasta) => {
        setFechaFH(fecha, horaDe, horaHasta);
        if(esOrigen)
            setSolicitaDeNuevoOrigen(false, 3);
        if(!esOrigen)
            setSolicitaDeNuevoDestino(false, 3);
        let esValido = await validaMatriz(fecha);
        if (!esValido)
            return;

        setCampo('');
        setDialogFechaFueraHorario(false);

    };

    const getVentanaFija = async () => {
        let servicioId = (esOrigen)?1:2;
        const result = await apiSource.obtenerAsync<any>("solicitud-servicio/get-ventana-servicio?clienteId=" + cliente.id + "&distribuidorId=" +recoleccion.distribuidor.id + "&servicioId=" +  servicioId + "&username=" +  localStorage.getItem("usuario_nombre"));
        return result;
    };

    return (<>
        <Box mt={4} mb={1} className="title-2">
            {esOrigen ? traducirMessage(192) : traducirMessage(191)}
        </Box>
        <Grid container spacing={2}>
            <Grid item xs={12} md={4} lg={4}>
                {
                    esOrigen
                        ? <Help comments={traducirMessage(255)} customStyle={{ top: "-10px", right: "-10px", color: campo == 'recoleccion' ? "#FFFFFF" : "#00653b" }} size="small" />
                        : <Help comments={traducirMessage(254)} customStyle={{ top: "-10px", right: "-10px", color: selectedOption == 1 ? "#FFFFFF" : "#00653b" }} size="small" />
                }

                <Box className={`pointer card medium-height ${esSolicitud && esOrigen ? campo == 'recoleccion' ? 'selected' : '' : seleccionaDefault ? 'selected' : ''}`}
                    display="flex"
                    flexDirection="column" justifyContent="center" style={{ padding: "10px 20px" }}
                    onClick={removeFecha}>
                    <Box className="title-4 green-label text-center">
                        {esOrigen &&
                            <b>
                                {/* Se puede pasar a recolectar en el horario disponible de Almex */
                                    traducirMessage(235)}
                            </b>
                        }
                        {!esOrigen &&
                            <b>
                                {/* Se puede pasar a entregar en el horario disponible de Almex */
                                    traducirMessage(234)}
                            </b>
                        }
                    </Box>

                    <Box className="title-4 text-center" my={1}>
                        <b>{
                            horarios?.map((h, i) => (
                                <div key={i}>{h}</div>
                            ))
                        }</b>
                    </Box>
                    {esOrigen && esSolicitud &&
                        <Box className="title-4 text-center">
                            {/* Favor de seleccionar la Fecha de Recolección */
                                traducirMessage(122)}
                        </Box>
                    }

                    {esOrigen && esSolicitud &&
                        <PickUpDateRecoleccion abierto={dialogFechaRecoleccion} onClose={cerrarDialogFechaRecoleccion} minDate={fechaString2} onSave={saveFechaRecoleccion}
                            value={valueRecoleccion} areaServicioRemitente={areaServicio} cliente={cliente} horarios={horarioArea} aplicaReglasVentana={aplicaReglasVentana} ventanaFijaParam={ventanaFija} esRecoleccionPuerto={esRecintoAduanal} />
                    }
                </Box>
            </Grid>

            {aceptaCita && <>
                <Grid item xs={12} md={4} lg={4}>
                    {esOrigen &&
                        <Help comments={traducirMessage(253)} customStyle={{ top: "-10px", right: "-10px", color: selectedOption == 2 ? "#FFFFFF" : "#00653b" }} size="small" />    
                    }
                    {!esOrigen &&
                        <Help comments={traducirMessage(252)} customStyle={{ top: "-10px", right: "-10px", color: selectedOption == 2 ? "#FFFFFF" : "#00653b" }} size="small" />    
                    }
                    <Grid container
                        className={`pointer card medium-height ${esOrigen ? campo == 'cita' ? 'selected' : '' : (seleccionaDefault || campo != 'cita') ? '' : 'selected'}`}
                        justify="center" alignItems="center" style={{ padding: "10px 20px 10px 10px" }}
                        onClick={abrirDialogFecha}>
                        <Grid item xs={3}>
                            <Box display="flex" flexDirection="column" alignItems="center">
                                <Box>
                                    <img src="image/icon-calendar.png" alt="icon" />
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item xs>
                            <Box display="flex" flexDirection="column" justifyContent="center">
                                <Box className="title-4 green-label" mb={1}>
                                    <b>{fechaString}</b>
                                </Box>
                                <Box className="title-4" flexGrow={1}>
                                    {horaString}
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </>
            }

            { esOrigen && esRadCedis && <>
                <Grid item xs={12} md={4} lg={4}>
                    <Help comments={traducirMessage(253)} customStyle={{ top: "-10px", right: "-10px", color: selectedOption == 4 ? "#FFFFFF" : "#00653b" }} size="small" />    
                    <Grid container
                        className={`pointer card medium-height ${esOrigen ? campo == 'citaCedis' ? 'selected' : '' : (seleccionaDefault || campo != 'citaCedis') ? '' : 'selected'}`}
                        justify="center" alignItems="center" style={{ padding: "10px 20px 10px 10px" }}
                        onClick={abrirDialogFechaCedis}>
                        <Grid item xs={3}>
                            <Box display="flex" flexDirection="column" alignItems="center">
                                <Box>
                                    <img src="image/icon-calendar.png" alt="icon" />
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item xs>
                            <Box display="flex" flexDirection="column" justifyContent="center">
                                <Box className="title-4 green-label" mb={1}>
                                    <b>{fechaStringCedis}</b>
                                </Box>
                                <Box className="title-4" flexGrow={1}>
                                    {horaStringCedis}
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </>
            }
            { !esOrigen && esEadCedis && <>
                <Grid item xs={12} md={4} lg={4}>
                    <Help comments={traducirMessage(252)} customStyle={{ top: "-10px", right: "-10px", color: selectedOption == 4 ? "#FFFFFF" : "#00653b" }} size="small" />    
                    <Grid container
                        className={`pointer card medium-height ${!esOrigen ? campo == 'citaCedis' ? 'selected' : '' : (seleccionaDefault || campo != 'citaCedis') ? '' : 'selected'}`}
                        justify="center" alignItems="center" style={{ padding: "10px 20px 10px 10px" }}
                        onClick={abrirDialogFechaCedis}>
                        <Grid item xs={3}>
                            <Box display="flex" flexDirection="column" alignItems="center">
                                <Box>
                                    <img src="image/icon-calendar.png" alt="icon" />
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item xs>
                            <Box display="flex" flexDirection="column" justifyContent="center">
                                <Box className="title-4 green-label" mb={1}>
                                    <b>{fechaStringCedis}</b>
                                </Box>
                                <Box className="title-4" flexGrow={1}>
                                    {horaStringCedis}
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </>
            }

            {aceptaCita && <>
                <Grid item xs={12} md={4} lg={4}>
                    {esOrigen &&
                        <Help comments={traducirMessage(253)} customStyle={{ top: "-10px", right: "-10px", color: selectedOption == 3 ? "#FFFFFF" : "#00653b" }} size="small" />
                    }
                    {!esOrigen &&
                        <Help comments={traducirMessage(252)} customStyle={{ top: "-10px", right: "-10px", color: selectedOption == 3 ? "#FFFFFF" : "#00653b" }} size="small" /> 
                    }
                    <Grid container
                        className={`pointer card medium-height ${esOrigen ? campo == 'citaFueraHorario' ? 'selected' : '' : (seleccionaDefault || campo != 'citaFueraHorario') ? '' : 'selected'}`}
                        justify="center" alignItems="center" style={{ padding: "10px 20px 10px 10px" }}
                        onClick={abrirDialogFechaFueraHorario}>
                        <Grid item xs={3}>
                            <Box display="flex" flexDirection="column" alignItems="center">
                                <Box>
                                    <img src="image/icon-calendar.png" alt="icon" />
                                </Box>
                            </Box>
                        </Grid>

                        <Grid item xs>
                            <Box display="flex" flexDirection="column" justifyContent="center">
                                <Box className="title-4 green-label" mb={1}>
                                    <b>{fechaStringFueraHorario}</b>
                                </Box>
                                <Box className="title-4" flexGrow={1}>
                                    {horaStringFH}
                                </Box>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>
            </>
            }
        </Grid>

        <PickUpDate abierto={dialogFecha} onClose={cerrarDialogFecha} minDate={fechaString2} onSave={saveFecha}
            value={valueCita} horarios={horarios} esOrigen={esOrigen} aplicaReglasVentana={aplicaReglasVentana} ventanaFija={ventanaFija}
            areaServicioRemitente={areaServicio} horariosAreaServicio={horarioArea} esSolicitud={esSolicitud} esRecoleccionPuerto={esRecintoAduanal}/>
        
        <PickUpDate abierto={dialogFechaCedis} onClose={cerrarDialogFechaCedis} minDate={fechaStringCedis} onSave={saveFechaCedis}
            value={valueCitaCedis} horarios={horarios} esOrigen={esOrigen} aplicaReglasVentana={aplicaReglasVentana} ventanaFija={ventanaFija}
            areaServicioRemitente={areaServicio} horariosAreaServicio={horarioArea} esSolicitud={esSolicitud} esRecoleccionPuerto={esRecintoAduanal}/>

        <PickUpDateFueraHorario abierto={dialogFechaFueraHorario} onClose={cerrarDialogFechaFueraHorario}
            minDate={fechaString2}
            onSave={saveFechaFueraHorario} value={valueCita} horarios={horarios} valueHoraDe={horaDeP}
            valueHoraHasta={horaHastaP} hor={horarioArea} esOrigen={esOrigen} horariosAreaServicio={horarioArea}
            aplicaReglasVentana={aplicaReglasVentana} ventanaFija={ventanaFija}
            areaServicioRemitente={areaServicio}
            esSolicitud={esSolicitud} esRecoleccionPuerto={esRecintoAduanal}
        />

        {
            showLoading &&
            <> <LoadingDialog titulo={traducirLabel(240)} abierto={true} /></>
        }
    </>)
};


const mapStateToProps = (state: ApplicationState) => ({
    cliente: state.cliente,
    solicitudCopia: state.solicitudCopia,
    usuario: state.usuario,
    ayuda: state.ayuda,
    paises: state.paises,
    recoleccionOrigen: state.recoleccionOrigen,
    recoleccionDestino: state.recoleccionDestino
});

const mapDispatchToProps = {
    setSolicitudCopia: setSolicitudCopia
};

export default connect(mapStateToProps, mapDispatchToProps)(RecoleccionFecha);

//export default RecoleccionFecha;
